import { Plus, Trash2 } from "lucide-react";

export const PriceOptionsEditor = ({ title, items, onChange, testid }) => {
  const update = (i, k, v) => onChange(items.map((it, j) => (j === i ? { ...it, [k]: k === "price" ? Number(v) || 0 : v } : it)));
  return (
    <div data-testid={testid}>
      <span className="text-xs text-[#A89F91] font-medium">{title}</span>
      <div className="mt-1.5 space-y-2">
        {items.map((it, i) => (
          <div key={i} className="flex gap-2">
            <input value={it.name} onChange={(e) => update(i, "name", e.target.value)} className="field-dark flex-1 min-w-0 rounded-lg px-3 py-2 text-sm" data-testid={`${testid}-name-${i}`} />
            <input type="number" value={it.price} onChange={(e) => update(i, "price", e.target.value)} className="field-dark w-24 rounded-lg px-3 py-2 text-sm" data-testid={`${testid}-price-${i}`} />
            <button type="button" onClick={() => onChange(items.filter((_, j) => j !== i))} className="p-2 text-[#A89F91] hover:text-red-400" data-testid={`${testid}-remove-${i}`}><Trash2 className="w-4 h-4" /></button>
          </div>
        ))}
        <button type="button" onClick={() => onChange([...items, { name: "", price: 0 }])} className="inline-flex items-center gap-1 text-xs text-amber-400 hover:text-amber-300" data-testid={`${testid}-add`}>
          <Plus className="w-3.5 h-3.5" /> Agregar opción
        </button>
      </div>
    </div>
  );
};
